import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from './credenciales';

export const firmarArchivo = async(body_request:any):Promise<any>=>{
    const MAX_ATTEMPTS = 100; // Número máximo de intentos
    const INTERVAL = 500; // Intervalo de tiempo entre intentos en ms

    let resultado = { msg: "", exitoso: true, url: "", url_registro_auditoria: "" };
    try{               
        // Referencia a la colección "documentos" (puedes cambiar el nombre de la colección)
        const docRef = doc(db, "documentos", body_request.id_documento);
        await setDoc(docRef, { 
            documentoData: body_request.documentoData || {},
            userData: body_request.userData || {},
            estado: "Completado"
        }, { merge: true });
        
        try {
            for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
                // Espera el intervalo antes de verificar
                await new Promise(resolve => setTimeout(resolve, INTERVAL));

                // Obtiene el documento actualizado
                const docSnapshot = await getDoc(docRef);
                if (docSnapshot.exists()) {
                    const data = docSnapshot.data();
                    // Verifica el estado del campo que deseas
                    if (data && data.estado === "Firmado") {
                        resultado.url = data.url_documento_firmado;
                        resultado.url_registro_auditoria = data.url_documento_auditoria;
                        return resultado;
                    }

                    if (data && data.estado === "Pendiente" && data.error_firma) {
                        resultado.exitoso = false;
                        resultado.msg = data.error_firma;
                        return resultado;
                    }
                }
            }
            // Timeout
            resultado.exitoso = false;
            resultado.msg = "Agotado el tiempo de espera intentando firmar el documento.";
            return resultado;
        } catch(error) {
            console.log(error);
            resultado.exitoso = false;
            resultado.msg = "Agotado tiempo de espera, se enviará el pdf firmado por email...";
        }
    }catch(error){
        resultado.exitoso = false;
        resultado.msg = JSON.stringify(error);
        console.log("Error en setDoc:", error);
    }

    return resultado;
}

export const registrarUsuarioEnDb = async (uid: string, email: string, empresa: string = ""): Promise<any> => {
    try {
        const userRef = doc(db, "usuarios", uid);
        
        // Lógica de seguridad simple:
        // Si viene 'empresa' (casos raros futuros), es admin.
        // Si NO viene 'empresa' (registro web), es usuario normal (admin: false).
        const esAdmin = empresa.length > 0; 

        await setDoc(userRef, {
            empresa: empresa, // Será "" en el registro web
            admin: esAdmin,   // Será false en el registro web
            email: email,
            fecha_registro: new Date()
        }, { merge: true });

        return { exitoso: true, msg: "Usuario registrado correctamente" };
    } catch (error: any) {
        console.error("Error al registrar en DB:", error);
        throw new Error("No se pudo guardar la ficha del usuario.");
    }
}
